export const ORDER_SETTINGS = {
    UPDATE_PREFERENCES: "order-update",

    TERMS_INPUT: "terms-input",
    TERMS_SAVE_BTN: "terms-save-btn",

    LEGAL_FILES: {
        CHANGE_MESSAGE: "change-message",
    },

    AUTO_ADJUST_TOGGLE: "auto_adjust_quantities_on_add-toggle",
    AUTO_ADJUST_CONTAINER: "auto_adjust_quantities_on_add-container",

    GROUP_BY_VALUE: "order_group_by-value",
    GROUP_BY_OPTION: "order_group_by-option",
    GROUP_BY_HINT_BUTTON: "order_group_by-hint-button",
    GROUP_BY_HINT: "order_group_by-hint",

    SORT_BY_VALUE: "order_sort_by-value",
    SORT_BY_OPTION: "order_sort_by-option",
    SORT_BY_HINT_BUTTON: "order_sort_by-hint-button",
    SORT_BY_HINT: "order_sort_by-hint",

    SORT_ORDER_VALUE: "order_sort_order-value",
    SORT_ORDER_OPTION: "order_sort_order-option",
    SORT_ORDER_HINT_BUTTON: "order_sort_order-hint-button",
    SORT_ORDER_HINT: "order_sort_order-hint",

    DISPLAY_OPTIONS_IN_ORDER_REVIEW_TOGGLE: "display_options_in_order_review-toggle",
    DISPLAY_OPTIONS_IN_ORDER_REVIEW_HINT_BUTTON: "display_options_in_order_review-hint-button",
    DISPLAY_OPTIONS_IN_ORDER_REVIEW_HINT: "display_options_in_order_review-hint",

    RESERVATION: {
        CONTAINER: "reservation-container",
        TOGGLE: "reservation-toggle",
        TOGGLE_HINT: "reservation-toggle-hint",
        PERIOD: "reservation-period",
        DATE: "reservation-date",
        TIME: "reservation-time",
        TIMEZONE: "reservation-timezone",
        ALERT: "reservation-alert",
        ALERT_HINT: "reservation-alert-hint",
        ALERT_HOURS: "reservation-alert-hours",
    },
};
